import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function LayerCore() {
  return <section className="py-24 bg-white" data-id="element-30">
      <div className="max-w-7xl mx-auto px-6" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-32">
          <div className="flex items-center gap-3 mb-4" data-id="element-33">
            <div className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-34">
              LAYER 3
            </div>
            <BookOpen className="w-5 h-5 text-red-600" data-id="element-35" />
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-36">
            The Scientific Core
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl" data-id="element-37">
            Intentionally clean and vanilla — unbiased edutainment. KEEs walk
            through study graphs with practical presenting tips. This is where
            credibility lives.
          </p>
        </motion.div>

        {/* Actual presentation slide */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-slate-200 bg-[#2d4a35]" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/5oJv7Wjm2S4dbgMF6Gvbr6/Screenshot_2026-05-07_at_1.17.49_PM.png" alt="TRALOSpeak Video Toolkit — Dr Firas George Hougeir presenting ECZTRA 3 ad hoc analysis" className="w-full h-auto block" data-id="element-39" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center text-slate-500 mt-12 italic" data-id="element-40">
          KEE on camera, slides on screen — credibility you can watch.
        </motion.p>
      </div>
    </section>;
}